import { render } from "./PortfolioPosters.vue?vue&type=template&id=00baf34c&scoped=true"
import script from "./PortfolioPosters.vue?vue&type=script&lang=js"
export * from "./PortfolioPosters.vue?vue&type=script&lang=js"

import "./PortfolioPosters.vue?vue&type=style&index=0&id=00baf34c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00baf34c"]])

export default __exports__